import React, { Component } from 'react';
import Combobox from 'react-widgets/lib/Combobox';

export default class SingleSelectInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.defaultValue,
      open: false,
    };
  }

  /**
  * In order to open the date time picker on click, we handle it with handleClick() and handleToggle()
  * https://github.com/jquense/react-widgets/issues/257
  */
  handleClick = (event) => {
    if (event.target.tagName === 'INPUT') {
      this.setState({ open: true });
    }
  }

  handleToggle = (view) => {
    this.setState({ open: view });
  }

  render() {
    return (
      <div>
        <Combobox
          {...this.props}
          onChange={v => {
            this.setState({ value: v[this.props.valueField] });
            if (this.props.onChange) {
              this.props.onChange(v);
            }
          }}
          open={this.state.open}
          onClick={this.handleClick}
          onToggle={this.handleToggle}
        />
        <input
          type="hidden"
          name={this.props.name}
          value={this.state.value}
        />
      </div>);
  }
}
